export const MedicineApplicationTimeSpanType = Object.freeze({
    Continuous: 'CONTINUOUS',
    Temporary: 'TEMPORARY'
});
